export const theme = {
    themeColor: "#F5B80F",
    secundaryColor: "#939597",
    thirdColor: "#fdf98b",
    fourthColor: "#C1E8DA",
    fifthColor: "#E0AAB7",
    white: "#FFFFFF",
    black: "#00000",
    lografAgendaTheme: "#76B39F"
}